export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8574.3a11082c.jpg";